class BuyButton extends HTMLElement {
  constructor() {
    super();
    
    this.button = null;
    this.variantId = null;
    this.quantity = 1;
    this.upsellProduct = null;
  }

  connectedCallback() {
    this.button = this.querySelector('.buy-button__btn');
    this.variantId = this.dataset.variantId;
    this.quantity = parseInt(this.dataset.quantity) || 1;
    
    if (this.button) {
      this.button.addEventListener('click', (e) => {
        e.preventDefault();
        this.addToCart();
      });
    }
    
    document.addEventListener('upsell-selected', (e) => {
      this.upsellProduct = e.detail;
    });
  }

  async addToCart() {
    if (!this.variantId) {
      console.error('No variant ID');
      this.showValidationError();
      return;
    }
    
    const hasUnselectedDropdowns = this.checkUnselectedDropdowns();
    if (hasUnselectedDropdowns) {
      this.showValidationError();
      return;
    }
    
    const sizeSelect = document.querySelector('select[name="properties[size]"]');
    const sizeDropdown = document.querySelector('custom-dropdown[data-option-name="Size"]');
    
    let sizeValue = null;
    if (sizeSelect && sizeSelect.value) {
      sizeValue = sizeSelect.value;
    } else if (sizeDropdown) {
      const selectedOption = sizeDropdown.querySelector('.variant-dropdown__option.selected');
      if (selectedOption) {
        sizeValue = selectedOption.dataset.propertyValue || selectedOption.dataset.value;
      }
    }
    
    if ((sizeSelect || sizeDropdown) && !sizeValue) {
      this.showValidationError();
      if (sizeSelect) {
        sizeSelect.style.borderColor = '#c00';
        setTimeout(() => {
          sizeSelect.style.borderColor = '';
        }, 3000);
      }
      if (sizeDropdown) {
        const trigger = sizeDropdown.querySelector('.variant-dropdown__trigger');
        if (trigger) {
          trigger.classList.add('error');
          setTimeout(() => {
            trigger.classList.remove('error');
          }, 3000);
        }
      }
      return;
    }
    
    this.classList.add('loading');
    
    try {
      const formData = {
        id: this.variantId,
        quantity: this.quantity,
      };
      
      if (sizeValue) {
        formData.properties = {
          'Size': sizeValue
        };
      }
      
      const items = [formData];
      
      if (this.upsellProduct && this.upsellProduct.variantId) {
        items.push({
          id: this.upsellProduct.variantId,
          quantity: 1
        });
      }
      
      let response;
      if (items.length > 1) {
        response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ items: items }),
        });
      } else {
        response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(formData),
        });
      }

      const data = await response.json();
      
      if (response.ok) {
        const productDetail = {
          product: data,
          addToCartBtn: this.button
        };

        this.dispatchEvent(new CustomEvent('product-added', {
          detail: data,
          bubbles: true,
        }));
        
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: productDetail }));
        document.dispatchEvent(new CustomEvent('cart:open'));
        
        this.openCartDrawer();
        this.updateCartCount();
      } else {
        console.error('Error adding to cart:', data);
        alert(data.description || 'Error adding to cart');
      }
    } catch (error) {
      console.error('Error:', error);
      alert('Error adding to cart');
    } finally {
      this.classList.remove('loading');
    }
  }

  showValidationError() {
    const dropdowns = document.querySelectorAll('custom-dropdown:not([data-type="upsell"])');
    
    dropdowns.forEach((dropdown) => {
      const selectedText = dropdown.querySelector('.variant-dropdown__selected');
      if (selectedText && selectedText.textContent.trim() === 'Select') {
        const trigger = dropdown.querySelector('.variant-dropdown__trigger');
        if (trigger) {
          trigger.classList.add('error');
          setTimeout(() => {
            trigger.classList.remove('error');
          }, 3000);
        }
      }
    });
    
    this.button.classList.add('shake');
    setTimeout(() => {
      this.button.classList.remove('shake');
    }, 500);
  }

  checkUnselectedDropdowns() {
    const dropdowns = document.querySelectorAll('custom-dropdown:not([data-type="upsell"])');
    let hasUnselected = false;
    
    dropdowns.forEach((dropdown) => {
      const selectedText = dropdown.querySelector('.variant-dropdown__selected');
      if (selectedText && selectedText.textContent.trim() === 'Select') {
        hasUnselected = true;
      }
    });
    
    return hasUnselected;
  }

  openCartDrawer() {
    const cartDrawerElement = document.querySelector('#CartDrawer, [id*="cart-drawer"], cart-drawer');
    
    if (cartDrawerElement) {
      if (typeof cartDrawerElement.open === 'function') {
        cartDrawerElement.open();
        return;
      }
      
      cartDrawerElement.classList.add('is-open', 'active');
      const checkbox = document.querySelector('#CartDrawer-Checkbox, input[id*="cart"]');
      if (checkbox) {
        checkbox.checked = true;
      }
      return;
    }
    
    if (window.theme && window.theme.cart) {
      if (typeof window.theme.cart.build === 'function') {
        window.theme.cart.build();
        return;
      }
      if (typeof window.theme.cart.open === 'function') {
        window.theme.cart.open();
        return;
      }
    }
    
    const cartTrigger = document.querySelector('[href="/cart"], .js-drawer-open-cart, [data-drawer-toggle="cart"]');
    if (cartTrigger) {
      cartTrigger.click();
      return;
    }
    
    window.location.href = '/cart';
  }

  async updateCartCount() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      
      const cartCount = document.querySelector('.cart-count, [data-cart-count]');
      if (cartCount) {
        cartCount.textContent = cart.item_count;
      }
      
      if (window.theme && window.theme.cart && window.theme.cart.getCart) {
        window.theme.cart.getCart();
      }
    } catch (error) {
      console.error('Error updating cart count:', error);
    }
  }

  changeVariantId(newVariantId) {
    this.variantId = newVariantId;
    this.dataset.variantId = newVariantId;
  }

  updateButtonText(price) {
    const textElement = this.querySelector('.text');
    if (!textElement) return;
    
    const extractText = (htmlString) => {
      if (!htmlString) return '';
      const temp = document.createElement('div');
      temp.innerHTML = htmlString;
      return temp.textContent || temp.innerText || '';
    };
    
    const cleanPrice = extractText(price);
    const baseText = 'ADD TO CART';
    
    if (cleanPrice) {
      textElement.textContent = `${baseText} - ${cleanPrice}`;
    } else {
      textElement.textContent = baseText;
    }
  }
}

if (customElements.get('buy-button') === undefined) {
  customElements.define('buy-button', BuyButton);
}

